import React from 'react';
import styled from 'styled-components';
import { CollaboratorPresence } from './useAwareness';

const Stack = styled.div`
    position: absolute;
    top: 12px;
    right: 16px;
    display: flex;
    flex-direction: row-reverse;
    gap: 0;
    pointer-events: auto;
    z-index: 30;
`;

const Avatar = styled.div<{ color: string }>`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid white;
    margin-left: -8px;
    background: ${({ color }) => color};
    color: white;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

interface Props {
    peers: CollaboratorPresence[];
}

/**
 * Stacked avatar list of remote collaborators. Mount inside MainSection so the
 * avatars overlay the top-right of the canvas without competing with the
 * top bar.
 */
export const CollaboratorAvatars: React.FC<Props> = ({ peers }) => {
    if (peers.length === 0) return null;
    return (
        <Stack aria-label="Collaborators">
            {peers.map(peer => (
                <Avatar key={peer.clientId} color={peer.user.color} title={peer.user.displayName}>
                    {peer.user.avatarUrl ? <img src={peer.user.avatarUrl} alt={peer.user.displayName} /> : initials(peer.user.displayName)}
                </Avatar>
            ))}
        </Stack>
    );
};

function initials(name: string): string {
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map(part => part.charAt(0).toUpperCase()).join('');
}
